import React, { memo, useState, useEffect, useCallback } from 'react'
import {
  Button,
  Image,
  Input,
  Section,
  InputTextarea,
  Table,
  Modal,
  Checkbox,
  Tabber,
  DatePickerInput,
  SelectBox,
  Text,
  ToggleCompareEvent,
  Spinner,
  ModalRequestUnseal,
  ConfirmModalRequestUnseal,
  CountdownFlipTimer,
  Breadcrumbs,
  InputUpload,
} from '../../components'
const TextareaApproval = memo(props => {
  const { valueApp, getValueTextArea } = props
  const [approvalNote, setApprovalNote] = useState('')
  const handlersChangeTextArea = e => {
    const noteValue = e.target.value
    setApprovalNote(noteValue)
  }
  useEffect(() => {
    let mount = true
    if (mount) {
      if (valueApp) {
        setApprovalNote(valueApp)
      }
    }
    return () => {
      mount = false
    }
  }, [valueApp])
  useEffect(() => {
    let mount = true
    if (mount) {
      getValueTextArea(approvalNote)
    }
    return () => {
      mount = false
    }
  }, [approvalNote])
  const renderContent = useCallback(() => {
    return (
      <Section className="form-col col-12">
        <Section className="form-group">
          <label>
            Note <br /> (Optional)
          </label>
          <Section className="form-group-control">
            <Section className="form-group-inner-wrapper">
              <InputTextarea
                value={approvalNote}
                onChange={handlersChangeTextArea}
                id="approval-note"
                {...props}
              />
            </Section>
          </Section>
        </Section>
      </Section>
    )
  }, [approvalNote])
  return renderContent()
})
TextareaApproval.defaultProps = {
  valueApp: '',
  getValueTextArea: () => {},
}
export default TextareaApproval
